// extracted by mini-css-extract-plugin
export default {"ConfirmText":"_ConfirmText--HYFeM","MarkAsDeclinedMenuItem":"_MarkAsDeclinedMenuItem--pod7N"};